<template>
    <div
        class="navigation-tree-item"
    >
        <label>
            <img
                :src="item.thumbnailUrl"
                width="18"
                height="auto"
                align="left"
                class="navigation-tree-item__thumb"
            >
            <span>{{ item.name | ellipses(42, 16) }}</span>
        </label>

        <i v-if="isFolder" class="navigation-tree-item__chevron-icon">
            <font-awesome-icon aria-hidden="true" :icon="['far', 'chevron-right']" />
        </i>
    </div>
</template>

<script>
import mapFilters from '@/utils/map-filters';
import { propValidator } from '@/utils/validators';

export default {
    name: 'navigation-tree-item',

    props: {
        item: {
            type: Object,
            default() {
                return {};
            },

            validate(value) {
                return propValidator(value, {
                    name: String,
                    children: Array,
                });
            },
        },

        itemIndex: {
            type: Number,
            default: 0,
        },

        columnIndex: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        isFolder() {
            return (this.item.children) && (this.item.children.length);
        },
    },

    methods: {
        ...mapFilters(['ellipses']),

        onClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss">
.navigation-tree-item {
    $this: &;

    line-height: 1.25;
    position: relative;
    padding: 4px 30px 4px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    font-size: $nav-item-font-size-default;
    transition: background-color 500ms ease;

    &:hover {
        color: var(--fileExplorer-hoverColor);
        background-color: var(--fileExplorer-hoverBackgroundColor);

        #{$this}__ellipsis-icon {
            svg {
                opacity: 1;
            }
        }
    }

    label {
        cursor: pointer;
        display: flex;
        align-items: center;
        width: 100%;
        overflow: hidden;

        span {
            flex-grow: 1;
            white-space: nowrap;
            overflow: hidden;
        }
    }

    &__chevron-icon {
        font-size: 11px;
        color: var(--fileExplorer-color);
        position: absolute;
        right: 10px;
    }

    &__thumb {
        margin-right: 5px;
    }
}
</style>
